import type { Game } from '../../../types'
import { teamId } from '../../../teams'

/**
 * Hardcoded fixtures for the demos. Props only — nothing here reads the store,
 * the season, or the clock.
 *
 * Kickoffs are a fixed past instant on purpose: a demo card must render the same frame today and
 * in March, and every demo that shows a card shows it in a state where the kickoff time is not on
 * screen (finished, or auto-predicted).
 */
const DEMO_KICKOFF = '2026-01-17T15:00:00.000Z'

export function demoGame(id: string, homeTeam: string, awayTeam: string): Game {
  // Through `teamId`, which throws on an unknown club — a typo in a demo fixture should fail the
  // suite, not render a card with a blank badge.
  return {
    id,
    gameweek: 1,
    homeTeam: teamId(homeTeam),
    awayTeam: teamId(awayTeam),
    kickoff: DEMO_KICKOFF,
  }
}

/** Every demo hands its inner components a click handler they will never fire (see `inert`). */
export const demoNoop = () => {}
